import { FormattedMessage } from 'react-intl';

import { Button, TextButton } from '@xing-com/button';
import {
  IconNotificationCenter,
  IconNotificationFilled,
} from '@xing-com/icons';
import { IllustrationPremiumSpotBell } from '@xing-com/illustrations';
import { Headline } from '@xing-com/typography';

import * as S from './styles';

type Props = {
  disabled?: boolean;
  isQuerySaved: boolean;
  onCreate: () => void;
  onClose: () => void;
};

export const LIContent: React.FC<Props> = ({
  disabled,
  isQuerySaved,
  onCreate,
  onClose,
}) => {
  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    onCreate();
  };

  return (
    <S.Form onSubmit={onSubmit}>
      <IllustrationPremiumSpotBell size="large" />
      <S.TextWrapper>
        <Headline size="xxlarge" noMargin>
          <FormattedMessage id="JOBS_SEARCH_ALERT_SUGGESTION_TITLE" />
        </Headline>
        <S.Text noMargin>
          <FormattedMessage id="JOBS_SEARCH_ALERT_SUGGESTION_MESSAGE" />
        </S.Text>
      </S.TextWrapper>
      <S.TextWrapper>
        <Button
          type="submit"
          variant="primary"
          icon={isQuerySaved ? IconNotificationFilled : IconNotificationCenter}
          disabled={disabled}
        >
          <FormattedMessage
            id={
              isQuerySaved
                ? 'JOBS_SEARCH_ALERT_CREATED'
                : 'JOBS_CREATE_SEARCH_ALERT'
            }
          />
        </Button>
        <TextButton type="button" onClick={onClose}>
          <FormattedMessage id="JOBS_CREATE_SEARCH_ALERT_CANCEL" />
        </TextButton>
      </S.TextWrapper>
    </S.Form>
  );
};
